<!------------ START TEMPLATE ------------>
<template>
  <Modal
    class="holamundo"
    :title="title"
    :active.sync="exibeModal"
    @close="closeModal"
  >
    <form role="form" @submit.stop.prevent="onSubmit">
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <span ref="mybtn">Produto</span>
          <v-select
            :options="produtos"
            name="Produto"
            id="Produto"
            v-model="formCadastro.produto"
            v-validate="{ required: true }"
            :state="validateState('Produto')"
            :class="validateClass('Produto')"
          ></v-select>
        </div>
        <div class="vx-col sm:w-1/4 w-full mb-2">
          <span>Valor</span>
          <vs-input
            class="w-full"
            name="Valor"
            id="Valor"
            v-model="formCadastro.valor"
            v-validate="{ required: true }"
            v-money="money"
            :state="validateState('Valor')"
            :danger="validateClass('Valor')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full mb-2">
          <vs-button color="success" class="mb-2 my-5">
            <span>Adicionar</span>
          </vs-button>
        </div>
      </div>
    </form>
    <vs-table :data="produtosValores" noDataText="Nenhum Produto Vinculado">
      <template slot="thead">
        <vs-th>Produto</vs-th>
        <vs-th>Valor</vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td
            class="vx-col sm:w-1/3 w-full mb-2"
            :data="data[indextr].nomeProduto"
            >{{ data[indextr].nomeProduto }}</vs-td
          >

          <vs-td
            class="vx-col sm:w-1/3 w-full mb-2"
            :data="data[indextr].valor"
          >
            {{ data[indextr].valor | currency }}
            <vs-icon icon="edit"></vs-icon>
            <template slot="edit">
              <vs-input v-model="tr.valor" />
              <vs-button
                @click="salvaValorVinculado(data[indextr].idTabelaValorProduto)"
                radius
                color="success"
                type="gradient"
                icon="save"
                class="d-inline ml-2"
              ></vs-button>
            </template>
          </vs-td>

          <vs-td
            class="vx-col sm:w-1/3 w-full mb-2"
            :data="data[indextr].idTabelaValorProduto"
          >
            <vs-button
              @click="
                deletaProdutoVinculado(data[indextr].idTabelaValorProduto)
              "
              radius
              color="danger"
              type="gradient"
              icon="clear"
              class="d-inline"
            ></vs-button>
          </vs-td>
        </vs-tr>
        <vs-tr v-if="produtosValores.length > 0">
          <vs-td class="vx-col sm:w-1/3 w-full mb-2">
            <b>Valor Total:</b>
          </vs-td>
          <vs-td class="vx-col sm:w-1/3 w-full mb-2">{{
            valorTotal | currency
          }}</vs-td>
          <vs-td class="vx-col sm:w-1/3 w-full mb-2"></vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </Modal>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import moment from 'moment';
import BotaoSubmit from './../../components/BotaoSubmit';
import vSelect from 'vue-select';
import service from '../../services';
import { VMoney } from 'v-money';
import Modal from '../../components/Modal.vue';

export default {
  props: ['modalSelecionado', 'popupActive', 'title', 'dados'],
  watch: {
    popupActive: function (newValue, oldValue) {
      this.exibeModal = newValue;
    },
    modalSelecionado: function (newValue, oldValue) {
      this.formCadastro = {
        idTabelaValor: newValue.idTabelaValor,
        produto: null,
        valor: '',
      };
      this.idTabelaValor = newValue.idTabelaValor;
      this.getProdutos(newValue.idGrupo);
      this.getProdutosValores(newValue.idTabelaValor);
    },
  },
  directives: { money: VMoney },
  data() {
    return {
      idTabelaValor: null,
      valorTotal: 0,
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      produtos: [],
      produtosValores: [],
      aguardeCadastro: false,
      exibeModal: false,
      formCadastro: {
        idTabelaValor: null,
        produto: null,
        valor: '',
      },
    };
  },
  methods: {
    salvaValorVinculado(idTabelaValorProduto) {
      var model = this.produtosValores.filter(
        (x) => x.idTabelaValorProduto == idTabelaValorProduto,
      );
      service
        .post('TabelaValoresProdutos', 'Atualizar', model[0])
        .then((res) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: `Operação Realizada com sucesso`,
            color: 'success',
          });
          this.getProdutosValores(this.idTabelaValor);
          this.$refs.mybtn.click();
        })
        .catch((error) => {
          this.aguardeCadastro = false;
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
        });
    },
    deletaProdutoVinculado(idTabelaValorProduto) {
      var ids = [];
      ids.push(idTabelaValorProduto);
      service
        .post('TabelaValoresProdutos', 'Inativar', { ids: ids })
        .then((res) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Produto desvinculado com sucesso',
            color: 'success',
          });
          this.$vs.loading.close();
          let array = this.produtosValores;
          for (var i = array.length - 1; i >= 0; i--) {
            if (array[i].idTabelaValorProduto == idTabelaValorProduto) {
              this.valorTotal = this.valorTotal - parseFloat(array[i].valor);
              array.splice(i, 1);
            }
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    getProdutosValores(id) {
      this.produtosValores = [];
      this.$vs.loading();
      service
        .getAll('TabelaValoresProdutos', {}, 'list/' + id)
        .then((res) => {
          this.produtosValores = [];
          res.data.forEach((element) => {
            element.nomeProduto = element.TabelaValores_Produtos.nomeProduto;
            this.valorTotal = this.valorTotal + element.valor;
            this.produtosValores.push(element);
          });
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    getProdutos(idGrupo) {
      this.produtos = [];
      service
        .getAll(
          'TabelaValoresProdutos',
          {},
          'listProdutosDisponiveis/' + idGrupo,
        )
        .then((res) => {
          res.data.forEach((element) => {
            this.produtos.push({
              id: element.idProduto,
              label: element.nomeProduto,
            });
          });
        });
    },
    onSubmit() {
      var action = 'Adicionar';
      var msgRetorno = `Registro Adicionado com sucesso`;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('TabelaValoresProdutos', action, this.formCadastro)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.produtosValores.push({
                idTabelaValorProduto: res.data.idTabelaValorProduto,
                nomeProduto: this.formCadastro.produto.label,
                valor: this.formCadastro.valor,
              });
              this.valorTotal =
                this.valorTotal + parseFloat(this.formCadastro.valor);
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    closeModal() {
      this.$emit('close');
    },
    formataData(data) {
      // formats data received from API
      var formattedData = moment(data).format('DD/MM/YYYY');
      return formattedData;
    },
    formataTexto(texto) {
      if (texto == true) return 'sim';
      if (texto == false) return 'não';
      return texto;
    },
  },
  mounted() {},
  components: {
    BotaoSubmit,
    vSelect,
    Modal
  },
};
</script>
<!------------ END SCRIPT ------------>
